// Object.groupBy polyfill for browsers that don't support it natively (Chrome <117, Firefox <119, Safari <17.4)
export function groupBy(
  items: Iterable<unknown>,
  callbackFn: (element: unknown, index: number) => PropertyKey,
): Record<PropertyKey, unknown[]> {
  const result: Record<PropertyKey, unknown[]> = Object.create(null)
  let index = 0
  for (const item of items) {
    const key = callbackFn(item, index++)
    const existing = result[key]
    if (existing) {
      existing.push(item)
    } else {
      result[key] = [item]
    }
  }
  return result
}

if (typeof Object.groupBy !== 'function') {
  Object.groupBy = groupBy as typeof Object.groupBy
}
